<!-- App.vue -->
<template>
  <Layout>
    <router-view />
  </Layout>
</template>

<script setup lang="ts">
import Layout from './components/layouts/Layout.vue';
import { useThemeStore } from './stores/theme';

// Initial theme setup
const themeStore = useThemeStore();
document.documentElement.setAttribute('data-theme', themeStore.theme);
</script>
